import React from 'react'
import styled from 'styled-components'
import icon from '../../assets/modal-alert.svg'
import itemIcon from '../../assets/check.svg'

export const ModalInformacion = ({close}) => {

    return (
        <Container>
            <Modal>
                <Alerta>
                    <Icon src={icon}/>   
                </Alerta>
                <Alerta>
                    <Titulo>¡Atención!</Titulo>
                </Alerta>
                <Alerta>
                    <Texto>
                        <Item><Check src={itemIcon}/>La asignatura Matemática I contempla el dictado de una clase teórica semanal (en los turnos mañana o noche) y una clase práctica.</Item>
                    </Texto>
                    <Texto>
                        <Item><Check src={itemIcon}/>El cursado de la clase práctica requiere la inscripción a través de SIU Guaraní en alguna de las comisiones.</Item>
                    </Texto>
                    <Texto>
                        <Item><Check src={itemIcon}/>La clase teórica no requiere inscripción.</Item>
                    </Texto>
                </Alerta>
                <Alerta>
                    <Cerrar onClick={close}>Entendido</Cerrar>
                </Alerta>
            </Modal>
        </Container>
    )
}

const Container = styled.div`
    display: block;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    padding-top: 200px;
    background-color: black;
    background-color: rgba(0, 0, 0, 0.4);
    -webkit-transition: 0.5s;
    overflow: auto;
    transition: all 0.3s linear;
`

const Modal = styled.div`
    padding: 20px;
    background-color: #fff;
    border-radius: 20px;
    max-width: 500px;
    height: auto;
    display: flex;
    flex-direction: column;
    margin-left: auto;
    margin-right: auto;
    @media(max-width: 768px){
        margin: 10px;
        max-width: 250px;
        margin-left: auto;
        margin-right: auto;
    }
`

const Cerrar = styled.button`
    cursor: pointer;
    border: none;
    padding: 15px 48px;
    width: 100%;
    background-color: #7778fe;
    border-radius: 14px;
    font-weight: 600;
    color: #fff;
    margin-top: 10px;
    @media(max-width: 768px){
        padding: 6px 40px;
        border-radius: 8px;
        font-size: 12px;
    }
`

const Alerta = styled.div`
    margin-left: auto;
    margin-right: auto;
    text-align: center;
`

const Icon = styled.img`
    width: 40px;
    height: 40px;
`

const Check = styled.img`
    width: 14px;
    height: 14px;
    margin-right: 10px;
    @media(max-width: 768px){
        width: 10px;
        height: 10px;
        margin-right: 4px;
    }
`

const Titulo = styled.div`
    font-weight: bold;
    font-size: 24px;
    color: #525252;
    margin-bottom: 10px;
    @media(max-width: 768px){
        font-size: 18px;
    }
`

const Texto = styled.div`
    color: #8F8F8F;
    font-weight: 600;
    font-size: 14px;
    @media(max-width: 768px){
        font-size: 11px;
        text-align: left;
    }
`

const Item = styled.div`
    margin-bottom: 10px;
`